import { render, staticRenderFns } from "./YesNoSwitch.vue?vue&type=template&id=2aea2a17&"
import script from "./YesNoSwitch.vue?vue&type=script&lang=ts&"
export * from "./YesNoSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports